import { render, staticRenderFns } from "./QuestionCommonError.vue?vue&type=template&id=572e8e15&"
import script from "./QuestionCommonError.vue?vue&type=script&lang=js&"
export * from "./QuestionCommonError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports